/* ============================================================
   adidas Blank Team Uniform Kit Builder — Goal Kick Soccer
   DOM contract lives in sections/adidas-uniform-builder.liquid.
   Data below is the adidas SS26 line list (MSRP). When the
   adidas teamwear products are loaded in Shopify, this data
   layer is the swap point: keys mirror the product metafields
   custom.teamwear_tier / team_color_code / kit_role / lifecycle_end.
   (NOT custom.color_family — that key is the storewide display-color
   filter list and means something else.)
   ============================================================ */
(function () {
  "use strict";

  var root = document.getElementById("adiuni");
  if (!root) return;

  var LEAD_BLANK = parseInt(root.dataset.leadBlank, 10) || 10;
  var LEAD_DECO = parseInt(root.dataset.leadDeco, 10) || 10;

  /* ===== adidas SS26 team color book. Key order is the display order for
     swatch rows; which pieces/sock models carry a color comes from CATALOG. ===== */
  var COLORS = {
    "white":             { hex: "#FFFFFF", label: "White" },
    "black":             { hex: "#15130F", label: "Black" },
    "power red":         { hex: "#C8102E", label: "Power Red" },
    "navy":              { hex: "#16264A", label: "Navy" },
    "royal":             { hex: "#0B4EA2", label: "Royal" },
    "light grey":        { hex: "#C3C8CE", label: "Light Grey" },
    "dark green":        { hex: "#153F2A", label: "Dark Green" },
    "collegiate purple": { hex: "#4B2E83", label: "Purple" },
    "team green":        { hex: "#0B6B3A", label: "Team Green" },
    "team yellow":       { hex: "#F5D200", label: "Team Yellow" },
    "team orange":       { hex: "#F0602B", label: "Team Orange" },
    "maroon":            { hex: "#6B1F2E", label: "Maroon" },
    "light blue":        { hex: "#7FC4E8", label: "Light Blue" }
  };
  var COLOR_ORDER = Object.keys(COLORS);
  var SOCK_ORDER = ["metro6", "copa", "hoop", "speed5", "speedpro"];

  var SOCKS = {
    metro6:   { name: "Metro 6 OTC",          art: "5155950", price: 12 },
    copa:     { name: "Copa Zone Cushion 5",  art: "5157957", price: 16 },
    hoop:     { name: "3 Stripe Hoop 2 OTC",  art: "5159082", price: 18 },
    speed5:   { name: "Team Speed 5 OTC",     art: "5161202", price: 20 },
    speedpro: { name: "Team Speed Pro 2 OTC", art: "5157954", price: 20 }
  };

  /* ===== Per-color article numbers + images, generated from the Shopify
     catalog (adidas SS26 teamwear products, data5 extraction Aug 24 2026 —
     regenerate with dev gen-catalog.js, never hand-edit). pieces[tier]
     [j|s][M|W|Y][colorKey] = art no. Colors absent from a piece map are
     colors adidas doesn't cut for that piece (SS26 book) — resolveGarment
     substitutes and labels them; don't "fix" by adding arts that don't
     exist. Image files follow "<art>_b2b010_plp.jpg" on the store CDN
     unless listed in imgExceptions; a null imgExceptions entry = product
     exists but has no usable /files/ image (render no photo). ===== */
  var CATALOG = {
      "cdnBase": "https://cdn.shopify.com/s/files/1/0425/7621/files/",
      "pieces": {
          "value": {
              "j": {
                  "M": {
                      "white": "DP3234",
                      "black": "DP3233",
                      "power red": "DP3230",
                      "navy": "DP3232",
                      "royal": "DP3231",
                      "light grey": "FT6558",
                      "dark green": "JN4489",
                      "collegiate purple": "JN4487",
                      "team green": "DP3238",
                      "team yellow": "JN4490",
                      "team orange": "II3497",
                      "maroon": "DP3239",
                      "light blue": "FT6561"
                  },
                  "Y": {
                      "white": "DP3221",
                      "black": "DP3220",
                      "power red": "DP3215",
                      "navy": "DP3219",
                      "royal": "DP3217",
                      "light grey": "FT6560",
                      "dark green": "JN4494",
                      "collegiate purple": "JN4491",
                      "team green": "DP3216",
                      "team yellow": "JN4495",
                      "team orange": "II3498",
                      "maroon": "DP3224",
                      "light blue": "FT6559"
                  }
              },
              "s": {
                  "M": {
                      "black": "FP9596"
                  },
                  "Y": {
                      "black": "FP9597"
                  }
              }
          },
          "standard": {
              "j": {
                  "M": {
                      "white": "KH4299",
                      "black": "JZ2505",
                      "power red": "JZ2501",
                      "navy": "JZ2504",
                      "royal": "JZ2506",
                      "light grey": "JZ2511",
                      "dark green": "KE9832",
                      "team green": "JZ2503",
                      "team yellow": "JZ2502",
                      "team orange": "JZ2509",
                      "maroon": "JZ2507"
                  },
                  "W": {
                      "white": "KH4298",
                      "black": "JZ2492",
                      "power red": "JZ2490",
                      "navy": "JZ2500",
                      "royal": "JZ2495",
                      "light grey": "JZ2494",
                      "team green": "JZ2491",
                      "team yellow": "JZ2493",
                      "team orange": "JZ2496",
                      "light blue": "JZ2498"
                  },
                  "Y": {
                      "white": "KH4300",
                      "black": "JZ2524",
                      "power red": "JZ2523",
                      "navy": "JZ2522",
                      "royal": "JZ2531",
                      "light grey": "JZ2525",
                      "dark green": "KE9834",
                      "team green": "JZ2528",
                      "team yellow": "JZ2529",
                      "maroon": "JZ2530",
                      "light blue": "JZ2527"
                  }
              },
              "s": {
                  "M": {
                      "white": "JZ2516",
                      "black": "JZ2521",
                      "power red": "JZ2517",
                      "navy": "JZ2513",
                      "royal": "JZ2520",
                      "light grey": "JZ2515",
                      "team green": "JZ2519",
                      "team yellow": "JZ2518",
                      "team orange": "JZ2512"
                  },
                  "W": {
                      "white": "JZ6542",
                      "black": "JZ6540",
                      "power red": "JZ6534",
                      "navy": "JZ6538",
                      "royal": "JZ6541",
                      "light grey": "JZ6536"
                  },
                  "Y": {
                      "white": "JZ6526",
                      "black": "JZ6531",
                      "power red": "JZ6528",
                      "navy": "JZ6532",
                      "royal": "JZ6524",
                      "light grey": "JZ6533",
                      "dark green": "KE9831",
                      "team green": "JZ6530",
                      "team yellow": "JZ6525",
                      "team orange": "JZ6529",
                      "maroon": "JZ6527"
                  }
              }
          },
          "competitive": {
              "j": {
                  "M": {
                      "white": "JG5834",
                      "black": "JG5832",
                      "power red": "JE2601",
                      "navy": "JG5830",
                      "royal": "JG5826",
                      "light grey": "JG5837",
                      "dark green": "JG5836",
                      "team green": "JN7485",
                      "team yellow": "JG5831",
                      "team orange": "JC8674",
                      "maroon": "JC8675",
                      "light blue": "JG5828"
                  },
                  "W": {
                      "white": "JI9992",
                      "black": "JI9986",
                      "power red": "JI9985",
                      "navy": "JI9987",
                      "royal": "JI9988",
                      "light grey": "JI9995",
                      "dark green": "JI9989",
                      "team green": "JN7487",
                      "team yellow": "JI9990",
                      "team orange": "JC8662",
                      "maroon": "JC8663",
                      "light blue": "JI9997"
                  },
                  "Y": {
                      "white": "JJ0058",
                      "black": "JJ0052",
                      "power red": "JJ0051",
                      "navy": "JJ0053",
                      "royal": "JJ0054",
                      "light grey": "JJ0061",
                      "dark green": "JJ0055",
                      "team green": "JN7486",
                      "team yellow": "JJ0056",
                      "team orange": "JC8666",
                      "maroon": "JC8667",
                      "light blue": "JJ0050"
                  }
              },
              "s": {
                  "M": {
                      "white": "JH3406",
                      "black": "JN5469",
                      "power red": "JN5466",
                      "navy": "JN5468",
                      "royal": "JN5465",
                      "light grey": "JN5467",
                      "dark green": "JH3411",
                      "team yellow": "JH3403",
                      "team orange": "JC8676",
                      "maroon": "JC8677",
                      "light blue": "JH3407"
                  },
                  "W": {
                      "white": "JJ0031",
                      "black": "JN7410",
                      "power red": "JN7407",
                      "navy": "JN7409",
                      "royal": "JN7406",
                      "light grey": "JN7408",
                      "dark green": "JJ0028",
                      "team yellow": "JJ0029",
                      "team orange": "JC8670",
                      "maroon": "JC8671",
                      "light blue": "JJ0034"
                  },
                  "Y": {
                      "white": "JJ2423",
                      "black": "JN5459",
                      "power red": "JN5456",
                      "navy": "JN5458",
                      "royal": "JN5455",
                      "light grey": "JN5457",
                      "dark green": "JJ2420",
                      "team yellow": "JJ2421",
                      "team orange": "JC8664",
                      "maroon": "JC8665",
                      "light blue": "JJ2426"
                  }
              }
          },
          "premium": {
              "j": {
                  "M": {
                      "white": "KB1350",
                      "black": "KB1348",
                      "power red": "KB1355",
                      "navy": "KB1360",
                      "royal": "KB1353",
                      "light grey": "KB1349",
                      "dark green": "KB1351",
                      "team yellow": "KB1358",
                      "light blue": "KH0712"
                  },
                  "W": {
                      "white": "KB1331",
                      "black": "KB3747",
                      "power red": "KB1336",
                      "navy": "KB1334",
                      "royal": "KB1332",
                      "light grey": "KB1333",
                      "dark green": "KB1330",
                      "team yellow": "KB1337",
                      "light blue": "KH0716"
                  },
                  "Y": {
                      "white": "KB1317",
                      "black": "KB1319",
                      "power red": "KB1315",
                      "navy": "KB1323",
                      "royal": "KB1314",
                      "light grey": "KB1324",
                      "dark green": "KB1322",
                      "team yellow": "KB1313",
                      "light blue": "KH0717"
                  }
              },
              "s": {
                  "M": {
                      "white": "KA8787",
                      "black": "KA8773",
                      "power red": "KA8791",
                      "navy": "KA8790",
                      "royal": "KA8779",
                      "light grey": "KA8781",
                      "dark green": "KA8785",
                      "team yellow": "KA8777",
                      "light blue": "KH0714"
                  },
                  "W": {
                      "white": "KB1259",
                      "black": "KB1264",
                      "power red": "KB1267",
                      "navy": "KA8843",
                      "royal": "KB1260",
                      "light grey": "KB1261",
                      "dark green": "KB1262",
                      "team yellow": "KB1265",
                      "light blue": "KH0715"
                  },
                  "Y": {
                      "white": "KA8813",
                      "black": "KA8819",
                      "power red": "KA8817",
                      "navy": "KA8821",
                      "royal": "KA8816",
                      "light grey": "KA8815",
                      "dark green": "KA8818",
                      "team yellow": "KA8822",
                      "light blue": "KH0713"
                  }
              }
          },
          "elite": {
              "j": {
                  "M": {
                      "white": "KR0321",
                      "black": "KA6169",
                      "power red": "KA6173",
                      "navy": "KA6168",
                      "royal": "KA6172",
                      "light grey": "KA6166",
                      "dark green": "KA6174",
                      "team green": "KA6235",
                      "team yellow": "KA6170",
                      "team orange": "KA6231"
                  },
                  "W": {
                      "white": "KR0320",
                      "black": "KA6192",
                      "power red": "KA6190",
                      "navy": "KA6188",
                      "royal": "KA6185",
                      "light grey": "KA6186",
                      "dark green": "KA6184",
                      "team green": "KA6254",
                      "team yellow": "KA6189",
                      "team orange": "KA6255"
                  },
                  "Y": {
                      "white": "KR0319",
                      "black": "KA6264",
                      "power red": "KA6216",
                      "navy": "KA6211",
                      "royal": "KA6212",
                      "light grey": "KA6215",
                      "dark green": "KA6214",
                      "team green": "KA6219",
                      "team yellow": "KA6218",
                      "team orange": "KA6213"
                  }
              },
              "s": {
                  "M": {
                      "white": "KR0315",
                      "black": "KA6181",
                      "power red": "KA6179",
                      "navy": "KA6182",
                      "royal": "KA6178",
                      "light grey": "KA6180",
                      "dark green": "KA6177",
                      "team green": "KA6175",
                      "team yellow": "KA6176",
                      "team orange": "KA8683"
                  },
                  "W": {
                      "white": "KR0317",
                      "black": "KA6224",
                      "power red": "KA6227",
                      "navy": "KA6222",
                      "royal": "KA6223",
                      "light grey": "KA6228",
                      "dark green": "KA6226",
                      "team green": "KA6220",
                      "team yellow": "KA6225",
                      "team orange": "KA8693"
                  },
                  "Y": {
                      "white": "KR0318",
                      "black": "KA6205",
                      "power red": "KA6209",
                      "navy": "KA6208",
                      "royal": "KA6207",
                      "light grey": "KA6204",
                      "dark green": "KA6206",
                      "team green": "KA6210",
                      "team yellow": "KA6202",
                      "team orange": "KA8695"
                  }
              }
          }
      },
      "socks": {
          "metro6": {
              "white": "5155950",
              "black": "5155951",
              "power red": "5155948",
              "navy": "5155945",
              "royal": "5155947",
              "light grey": "5155949"
          },
          "copa": {
              "white": "5157957",
              "black": "5157967",
              "power red": "5157961",
              "navy": "5157948",
              "royal": "5157968",
              "light grey": "5157951",
              "dark green": "5157947",
              "collegiate purple": "5157949",
              "team green": "5157958",
              "team yellow": "5157943",
              "team orange": "5157956",
              "maroon": "5157953",
              "light blue": "5157960"
          },
          "hoop": {
              "white": "5159082",
              "black": "5159083",
              "power red": "5159078",
              "navy": "5159079",
              "royal": "5159081",
              "light grey": "5159080"
          },
          "speed5": {
              "white": "5161202",
              "black": "5161204",
              "power red": "5161206",
              "navy": "5161207",
              "royal": "5161208"
          },
          "speedpro": {
              "white": "5157954",
              "black": "5157964",
              "power red": "5157944",
              "navy": "5157946",
              "royal": "5157963",
              "dark green": "5157955",
              "collegiate purple": "5157950"
          }
      },
      "imgExceptions": {
          "5155945": "https://cdn.shopify.com/s/files/1/0425/7621/products/adidas-metro-6-otc-soccer-socks-759656.jpg",
          "5155947": "adidas-metro-6-otc-soccer-socks-756891.webp",
          "5155948": "adidas-metro-6-otc-soccer-socks-625827.webp",
          "5155949": "adidas-metro-6-otc-soccer-socks-550231_be37a6f8-2c5c-41c3-820a-9f864ee28006.jpg",
          "5155950": "adidas-metro-6-otc-soccer-socks-468226_936509c6-bdd3-4b7e-b420-514d39a96d07.jpg",
          "5155951": "https://cdn.shopify.com/s/files/1/0425/7621/products/adidas-metro-6-otc-soccer-socks-726279.jpg",
          "5157943": "adidas-copa-zone-cushion-5-otc-6708681_ef6d1e40-3ece-4470-90de-bb0952d54cdb.png",
          "5157944": "1e2dfca5c8bf7e5b82ab904c7e126e2c73a6fe29.jpg",
          "5157946": "79a3ff3a11daf36f63c0f79c2bdf47cb13a7f526.jpg",
          "5157947": "adidas-copa-zone-cushion-5-otc-socks-8608802.webp",
          "5157948": "adidas-copa-zone-cushion-5-otc-652405.png",
          "5157949": "adidas-copa-zone-cushion-5-otc-socks-6106195.webp",
          "5157950": "4cc2a56d316c796070c9dfcc277b3d34256c1bec.jpg",
          "5157951": "adidas-copa-zone-cushion-5-otc-socks-1264587.webp",
          "5157953": "adidas-copa-zone-cushion-5-otc-socks-5082922.webp",
          "5157954": "0877af88fdccf2c8d98373c27e12ec51c5c73c7e.jpg",
          "5157955": "55a3e77513efb3ba649dfb27e4332b9a400c9b45.jpg",
          "5157956": "adidas-copa-zone-cushion-5-otc-socks-7025404.webp",
          "5157957": "adidas-copa-zone-cushion-5-otc-896957.png",
          "5157958": "iowa-odp-adidas-copa-zone-cushion-v-otc-team-green-8285217_1d68a203-aa4e-402f-8df5-c5336f8be56d.png",
          "5157960": "adidas-copa-zone-cushion-5-otc-socks-5729832.webp",
          "5157961": "adidas-copa-zone-cushion-5-otc-4355870.png",
          "5157963": "4d6fc76aafe0bcc76d47dc4dca014ce118c53206.jpg",
          "5157964": "ff5905d6edff7c9b31b3b07aa168a669ac82d1f0.jpg",
          "5157967": "adidas-copa-zone-cushion-5-otc-107618.png",
          "5157968": "masc-uniforms-copa-zone-cushion-5-sock-7114475_7a3d09ab-3e93-47b9-af43-833e71709c8a.jpg",
          "5159078": "7d471be2f3272bbb9324bf2fdb1ddb01c5a36b72.jpg",
          "5159079": "5c920881a4fd818fbe64c9fc4ed6fd17bf7b46b1.jpg",
          "5159080": "a438ed51c93d4616a96485b5e88d201e0f92b0ee.jpg",
          "5159081": "473608221939cdb9d38e2c7c608da1372d516a62.jpg",
          "5159082": "4b883d78015788046105d560621eafa5297a67f6.jpg",
          "5159083": "1177af1a2ae1ed351e4643b7f546c18faf04d83e.jpg",
          "5161202": "4c04dcfd0ecd5e7fdad7704110a8cdd2191bcf62.jpg",
          "5161204": "3e64f0fcfd712ef8521c51e7d7ab45f13723d738.jpg",
          "5161206": "9fe87393a6407a6ef7eaf9d8bc344c6b023ec7a0.jpg",
          "5161207": "9836249b5d719639c43b736821425abe6f831f8f.jpg",
          "5161208": "959709957c8da7a23e1efaf367a47bf9d98bff02.jpg",
          "DP3230": "DP3230_b2b012_plp.jpg",
          "DP3231": "DP3231_b2b012_plp.jpg",
          "DP3232": "DP3232_b2b012_plp.jpg",
          "DP3233": "DP3233_b2b012_plp.jpg",
          "DP3234": "DP3234_b2b012_plp.jpg",
          "DP3238": "DP3238_b2b012_plp.jpg",
          "DP3239": "DP3239_b2b012_plp.jpg",
          "FP9596": "FP9596_b2b012_plp.jpg",
          "FP9597": "FP9597_b2b012_plp.jpg",
          "FT6558": "FT6558_b2b012_plp.jpg",
          "FT6561": "FT6561_b2b012_plp.jpg",
          "II3497": "II3497_b2b012_plp.jpg",
          "JN4487": "JN4487_b2b012_plp.jpg",
          "JN4489": "JN4489_b2b012_plp.jpg",
          "JN4490": "JN4490_b2b012_plp.jpg",
          "JN4491": null,
          "JZ2512": "JZ2512_b2b010_plp_b73c77f3-cecb-4e28-8df2-6cb1c1208f88.jpg",
          "JZ2513": "JZ2513_b2b010_plp_af6ad3dc-7dfc-4aad-93e5-41fc61e40a93.jpg",
          "JZ2515": "JZ2515_b2b010_plp_5a0bf084-2063-4ce5-8d81-850cbed4a5e8.jpg",
          "JZ2516": "JZ2516_b2b010_plp_a9208c78-b0e0-4e51-a47c-5777d03b0aa1.jpg",
          "JZ2517": "JZ2517_b2b010_plp_67b49c95-0c0e-4724-b4d4-093e1a731b5a.jpg",
          "JZ2518": "JZ2518_b2b010_plp_ba9921f0-51d1-48ee-94d8-6adc3f2d950c.jpg",
          "JZ2519": "JZ2519_b2b010_plp_82e3312c-a47a-4cc5-905d-d58b51286d41.jpg",
          "JZ2520": "JZ2520_b2b010_plp_c241f37c-43a1-4e8c-9a7f-aa331ccf6467.jpg",
          "JZ2521": "JZ2521_1_APPAREL_Photography_FrontCenterView_transparent.png",
          "JZ6541": "JZ6541_b2b010_plp_628c1f19-7e18-496b-a24e-c9b8323e12e3.jpg",
          "KA6169": "KA6169_b2b020_pdp.jpg",
          "KA6184": "KA6184_1_APPAREL_Photography_FrontCenterView_transparent.png",
          "KA6185": "KA6185_2_APPAREL_Photography_FrontCenterView_transparent.png",
          "KA6186": "KA6186_1_APPAREL_Photography_FrontCenterView_transparent.png",
          "KA6188": "KA6188_1_APPAREL_Photography_FrontCenterView_transparent.png",
          "KA6189": "KA6189_1_APPAREL_Photography_FrontCenterView_transparent.png",
          "KA6190": "KA6190_1_APPAREL_Photography_FrontCenterView_transparent.png",
          "KA6192": "KA6192_1_APPAREL_Photography_FrontCenterView_transparent.png",
          "KA6220": "KA6220_1_APPAREL_Photography_FrontCenterView_transparent.png",
          "KA6222": "KA6222_1_APPAREL_Photography_FrontCenterView_transparent.png",
          "KA6223": "KA6223_1_APPAREL_Photography_FrontCenterView_transparent.png",
          "KA6224": "KA6224_1_APPAREL_Photography_FrontCenterView_transparent.png",
          "KA6225": null,
          "KA6226": "KA6226_1_APPAREL_Photography_FrontCenterView_transparent.png",
          "KA6227": "KA6227_1_APPAREL_Photography_FrontCenterView_transparent.png",
          "KA6228": "KA6228_1_APPAREL_Photography_FrontCenterView_transparent.png",
          "KA6254": "KA6254_1_APPAREL_Photography_FrontCenterView_transparent.png",
          "KA6255": null,
          "KA8683": null,
          "KA8693": "KA8693_1_APPAREL_Photography_FrontCenterView_transparent.png",
          "KA8773": "Tiro26_League_Shorts_Black_KA8773_21_model.jpg",
          "KA8777": null,
          "KA8779": "Tiro26_League_Shorts_Blue_KA8779_21_model.jpg",
          "KA8781": null,
          "KA8785": "Tiro26_League_Shorts_Green_KA8785_21_model.jpg",
          "KA8787": "Tiro26_League_Shorts_White_KA8787_21_model.jpg",
          "KA8790": "Tiro26_League_Shorts_Blue_KA8790_HM1.jpg",
          "KA8791": "Tiro26_League_Shorts_Red_KA8791_21_model.jpg",
          "KA8813": "Tiro26_League_Kids_Shorts_White_KA8813_21_model.jpg",
          "KA8815": "Tiro26_League_Kids_Shorts_Grey_KA8815_20_01_model.jpg",
          "KA8816": "Tiro26_League_Kids_Shorts_Blue_KA8816_20_01_model.jpg",
          "KA8817": null,
          "KA8818": null,
          "KA8819": "Tiro26_League_Kids_Shorts_Black_KA8819_20_01_model.jpg",
          "KA8821": "Tiro26_League_Kids_Shorts_Blue_KA8821_21_model.jpg",
          "KA8822": null,
          "KA8843": "Tiro26_League_Short_Shorts_Blue_KA8843_21_model.jpg",
          "KB1259": "Tiro_26_League_Short_Shorts_White_KB1259_21_model_4f1fb5d8-ff47-40a0-ba0a-e0510c3698b0.jpg",
          "KB1260": null,
          "KB1261": null,
          "KB1262": "Tiro26_League_Short_Shorts_Green_KB1262_21_model.jpg",
          "KB1264": "Tiro_26_League_Short_Shorts_Black_KB1264_21_model.jpg",
          "KB1265": null,
          "KB1267": "Tiro_26_League_Short_Shorts_Red_KB1267_21_model_ae0eea96-1b95-4158-a88f-8c19c7b7f1fe.jpg",
          "KB1313": "KB1313_b2b012_plp.png",
          "KB1314": "KB1314_b2b012_plp.png",
          "KB1315": "KB1315_b2b012_plp.png",
          "KB1317": "KB1317_b2b012_plp.png",
          "KB1319": "KB1319_b2b012_plp.png",
          "KB1322": "KB1322_b2b012_plp.png",
          "KB1323": "KB1323_b2b012_plp.png",
          "KB1324": "KB1324_b2b012_plp.png",
          "KB1330": "KB1330_b2b012_plp_37edfcd0-17eb-4bd4-9c34-6cc4a34eb83d.png",
          "KB1331": "KB1331_b2b012_plp.png",
          "KB1332": "KB1332_b2b012_plp.png",
          "KB1333": "KB1333_b2b012_plp.png",
          "KB1334": "KB1334_b2b012_plp.png",
          "KB1336": "KB1336_b2b012_plp.png",
          "KB1337": "KB1337_b2b012_plp.png",
          "KB1348": "KB1348_b2b012_plp.png",
          "KB1349": "KB1349_b2b012_plp.png",
          "KB1350": "KB1350_b2b012_plp.png",
          "KB1351": "KB1351_b2b012_plp.png",
          "KB1353": "KB1353_b2b012_plp.png",
          "KB1355": "KB1355_b2b012_plp.png",
          "KB1358": "KB1358_b2b012_plp.png",
          "KB1360": "KB1360_b2b012_plp.png",
          "KB3747": "KB3747_b2b012_plp.png",
          "KH0712": "KH0712_b2b012_plp.png",
          "KH0713": null,
          "KH0714": null,
          "KH0715": null,
          "KH0716": "KH0716_b2b012_plp.png",
          "KH0717": "KH0717_b2b012_plp.png",
          "KR0317": "KR0317_1_APPAREL_Photography_FrontCenterView_transparent.png",
          "KR0320": "KR0320_1_APPAREL_Photography_FrontCenterView_transparent.png"
      }
  };

  function artFor(piece, colorKey, tier, gender) {
    tier = tier || state.tier; gender = gender || state.gender;
    var t = CATALOG.pieces[tier.id];
    var byG = t && t[piece];
    var m = byG && (byG[gender] || byG.M);
    return (m && m[colorKey]) || null;
  }
  function sockArtFor(model, colorKey) {
    var m = CATALOG.socks[model];
    return (m && m[colorKey]) || null;
  }
  function sockModelsFor(colorKey) {
    return SOCK_ORDER.filter(function (mod) { return sockArtFor(mod, colorKey); });
  }
  /* adidas cuts shorts palettes narrower than jerseys (Entrada shorts 6 of 12,
     Estro shorts black-only). When the kit color isn't made for a piece,
     substitute the classic pairing — black, or white on a black kit — and say
     so everywhere the piece is shown. Mirrors the resolveSock pattern. */
  function resolveGarment(piece, colorKey, tier, gender) {
    tier = tier || state.tier; gender = gender || state.gender;
    var exact = artFor(piece, colorKey, tier, gender);
    if (exact) return { colorKey: colorKey, art: exact, subbed: false };
    var t = CATALOG.pieces[tier.id];
    var m = t && t[piece] && (t[piece][gender] || t[piece].M);
    if (!m) return { colorKey: colorKey, art: null, subbed: false }; /* no catalog map — legacy tier-art fallback */
    var order = colorKey === "black" ? ["white", "black"] : ["black", "white"];
    var pick = order.filter(function (k) { return m[k]; })[0] ||
      COLOR_ORDER.filter(function (k) { return m[k]; })[0];
    return { colorKey: pick, art: m[pick], subbed: true };
  }
  /* Swatch palette = the jersey colors adidas actually cuts for this tier+cut. */
  function tierColors(t, gender) {
    gender = gender || state.gender;
    var tp = CATALOG.pieces[t.id];
    var m = tp && tp.j && (tp.j[gender] || tp.j.M);
    if (m) return COLOR_ORDER.filter(function (k) { return m[k]; });
    return t.colors;
  }
  /* Only call with an art number that came from CATALOG — legacy fallback
     arts have no CDN file and would 404. A null imgExceptions entry means
     the catalog product exists but has no usable image. */
  function imgFor(art) {
    if (!art) return null;
    var f = CATALOG.imgExceptions.hasOwnProperty(art) ? CATALOG.imgExceptions[art] : art + "_b2b010_plp.jpg";
    if (!f) return null;
    /* a full URL (e.g. legacy /products/ CDN path) is used as-is */
    return (/^https?:\/\//.test(f) ? f : CATALOG.cdnBase + f) + "?width=200";
  }

  var TIERS = [
    { id: "value", rank: "Tier 1", name: "Value", note: "Estro 19 — rec &amp; academy", life: 2027,
      take: "The honest rec-and-academy choice. It's a blended fabric with no cooling tech named, and it stops at 2XL with no tall sizes — but at this price that's a fair trade, and it's stocked through 2027.",
      spec: { fabric: "51% polyester / 49% recycled", tech: "No cooling tech listed", sizes: "XS–2XL · no tall sizes" },
      jersey: "Estro 19 Jersey", short: "Estro 19 Shorts", sock: "metro6", art: { j: "DP3231", s: "DP3246" },
      price: { M: { j: 15, s: 14 }, W: null, Y: { j: 12, s: 12 } },
      colors: ["white", "black", "power red", "navy", "royal", "light grey", "team green", "team orange", "maroon", "dark green", "light blue", "collegiate purple", "team yellow"] },
    { id: "standard", rank: "Tier 2", name: "Club Standard", note: "Entrada 26 head to toe", flag: "Best value · most teams", life: 2029,
      take: "What I'd put most club and school teams in. It's the same 100% recycled fabric as ranges costing twice as much, it's the only range carrying the full tall size run, and it's reorderable through 2029 — no other adidas kit gives you four years.",
      spec: { fabric: "100% recycled polyester", tech: "CLIMACOOL", sizes: "XS–3XL · full tall run to 4XLT" },
      jersey: "Entrada 26 Jersey", short: "Entrada 26 Shorts", sock: "metro6", art: { j: "JZ2504", s: "JZ2519" },
      price: { M: { j: 20, s: 18 }, W: { j: 20, s: 18 }, Y: { j: 18, s: 16 } },
      colors: ["white", "black", "power red", "navy", "royal", "light grey", "team yellow", "team green"] },
    { id: "competitive", rank: "Tier 3", name: "Competitive", note: "Squadra 25, incl. GK", life: 2028,
      take: "The step up for competitive club sides, and the only tier with a goalkeeper range built in. AEROREADY instead of CLIMACOOL — a different adidas cooling system, not a better one.",
      spec: { fabric: "100% recycled polyester", tech: "AEROREADY", sizes: "XS–3XL" },
      jersey: "Squadra 25 Jersey", short: "Squadra 25 Shorts", sock: "copa", art: { j: "IT3567", s: "IT3589" },
      price: { M: { j: 35, s: 25 }, W: { j: 35, s: 25 }, Y: { j: 30, s: 20 } },
      colors: ["white", "black", "power red", "navy", "royal", "light grey", "team yellow", "team green", "team orange", "maroon", "light blue"] },
    { id: "premium", rank: "Tier 4", name: "Premium", note: "Tiro 26 League", flag: "Coach's pick", life: 2027,
      take: "If it were my budget and my competitive program, this is what I'd buy. On paper it's the same fabric as Entrada — what you're paying for is the cut detail and the way it looks on a roster, which is worth it at this level but not at rec.",
      spec: { fabric: "100% recycled polyester", tech: "CLIMACOOL", sizes: "XS–3XL" },
      jersey: "Tiro 26 League Jersey", short: "Tiro 26 League Shorts", sock: "hoop", art: { j: "JV4571", s: "JV4602" },
      price: { M: { j: 40, s: 35 }, W: { j: 40, s: 35 }, Y: { j: 35, s: 30 } },
      colors: ["white", "black", "power red", "navy", "royal", "light grey", "team yellow", "dark green", "light blue"] },
    { id: "elite", rank: "Tier 5", name: "Elite", note: "Tiro 26 Competition", life: 2027,
      take: "Top of the adidas stock book. Buy it because you want the best available, not because your level requires it — the spec sheet barely separates it from Tiro League.",
      spec: { fabric: "100% recycled polyester", tech: "CLIMACOOL", sizes: "XS–3XL" },
      jersey: "Tiro 26 Comp Match Jersey", short: "Tiro 26 Comp Match Shorts", sock: "speed5", art: { j: "JV4498", s: "JV4530" },
      price: { M: { j: 60, s: 40 }, W: { j: 60, s: 40 }, Y: { j: 60, s: 40 } },
      colors: ["white", "black", "power red", "navy", "royal", "light grey", "team yellow", "team orange", "team green", "dark green"] }
  ];

  var GENDERS = [{ k: "M", label: "Men's" }, { k: "W", label: "Women's" }, { k: "Y", label: "Youth" }];

  var PRESETS = [
    { id: "match",  label: "Match kit",       sub: "1 · 1 · 1", j: 1, s: 1, k: 1 },
    { id: "ha",     label: "Home &amp; away", sub: "2 · 1 · 2", j: 2, s: 1, k: 2 },
    { id: "full",   label: "Full double",     sub: "2 · 2 · 2", j: 2, s: 2, k: 2 },
    { id: "jersey", label: "Jerseys only",    sub: "1 · 0 · 0", j: 1, s: 0, k: 0 }
  ];

  /* per-player add-ons unless team:true. Prices are adidas 2027 MSRP (verified vs 2027 Soccer Specialty book). */
  var ADDONS = [
    { id: "tee",     name: "Practice jersey", sub: "Entrada 26 Polyester Tee",  price: 22, max: 4 },
    { id: "bib",     name: "Training bib",    sub: "adidas Training Bib",       price: 15, max: 4 },
    { id: "jkt",     name: "Warm-up jacket",  sub: "Tiro 26 League Trg Jacket", price: 55, max: 2 },
    { id: "pnt",     name: "Warm-up pant",    sub: "Tiro 26 League Pants",      price: 50, max: 2 },
    { id: "sack",    name: "Sackpack",        sub: "Tournament III",            price: 14, max: 2 },
    { id: "pack",    name: "Backpack",        sub: "Striker 3",                 price: 48, max: 2 },
    { id: "duffel",  name: "Duffel",          sub: "Defender 5 Medium",         price: 50, max: 2 },
    { id: "ballbag", name: "Ball bag",        sub: "Stadium — one per team",    price: 55, max: 4, team: true }
  ];

  /* Decoration priced per garment. `on` = jersey or short. */
  var DECO_ITEMS = [
    { id: "numBack",  name: "Number, 8\" back",  sub: "Meets most league rules", price: 4.95, on: "j" },
    { id: "numFront", name: "Number, 4\" front", sub: "Optional",                price: 3.95, on: "j" },
    { id: "name",     name: "Player name, back", sub: "2\" varsity lettering",   price: 6.95, on: "j" },
    { id: "logo",     name: "Left chest logo",   sub: "1 colour",                price: 9.95, on: "j" },
    { id: "sponsor",  name: "Sponsor, front",    sub: "1 colour",                price: 6.95, on: "j" },
    { id: "numShort", name: "Number on shorts",  sub: "Useful at tournaments",   price: 3.95, on: "s" }
  ];
  var DECO_PRESETS = [
    { id: "blank",  label: "Blank",          items: [] },
    { id: "league", label: "League minimum", items: ["numBack"] },
    { id: "std",    label: "Standard",       items: ["numBack", "logo"] },
    { id: "club",   label: "Full club",      items: ["numBack", "name", "logo", "numShort"] }
  ];

  /* Breaks count garment PIECES across the whole order (jerseys, shorts,
     socks, add-ons, team items — decoration excluded), mirroring the
     Shopify automatic discounts on the `team-uniforms` collection
     (12+/24+/48+ items → 15/20/25%). Keep the two in step. */
  var BREAKS = [
    { min: 1,  off: 0,    label: "1–11 pieces" },
    { min: 12, off: 0.15, label: "12+ pieces" },
    { min: 24, off: 0.20, label: "24+ pieces" },
    { min: 48, off: 0.25, label: "48+ pieces" }
  ];

  var LIFECYCLE = [
    { name: "Entrada 26",           sub: "Jersey · shorts · LS · graphic", start: 2026, end: 2029.6,  cls: "best", tag: "Through 2029" },
    { name: "Tiro 26 Competition",  sub: "Match day · training · GK",      start: 2026, end: 2027.9,  cls: "good", tag: "Through 2027" },
    { name: "Tiro 26 League",       sub: "Jersey · shorts · outerwear",    start: 2026, end: 2027.9,  cls: "good", tag: "Through 2027" },
    { name: "Squadra 25",           sub: "Includes goalkeeper",            start: 2025, end: 2028.4,  cls: "good", tag: "Through 2028" },
    { name: "Estro 19",             sub: "Jersey &amp; shorts",            start: 2025, end: 2027.9,  cls: "good", tag: "Through 2027" },
    { name: "Tabela 23",            sub: "Hooped jersey",                  start: 2025, end: 2027.9,  cls: "good", tag: "Through 2027" },
    { name: "Team Icon 25",         sub: "Short &amp; long sleeve",        start: 2025, end: 2026.9,  cls: "dead", tag: "Ends Nov 2026" },
    { name: "Fortore 23",           sub: "Jersey &amp; shorts",            start: 2025, end: 2026.9,  cls: "dead", tag: "Ends Nov 2026" },
    { name: "Entrada 22 · Tiro 24", sub: "Still sold by competitors",      start: 2025, end: 2026.05, cls: "dead", tag: "Discontinued" }
  ];

  var state = {
    tier: TIERS[1], gender: "M", color: "navy", color2: "white", qty: 18,
    kit: { j: 1, s: 1, k: 1 },
    addons: {}, deco: {}, needBy: null
  };
  var color2Wanted = null; /* the buyer's last explicit away pick — restored whenever a tier supports it */
  var sockWanted = null;   /* the buyer's explicit sock model pick — null = tier suggestion; survives tier switches */
  ADDONS.forEach(function (a) { state.addons[a.id] = 0; });
  DECO_ITEMS.forEach(function (d) { state.deco[d.id] = false; });
  DECO_PRESETS.filter(function (x) { return x.id === "std"; })[0].items.forEach(function (id) { state.deco[id] = true; });

  var summaryEdited = false;

  var $ = function (id) { return document.getElementById(id); };
  var money = function (n) { return "$" + n.toLocaleString("en-US", { maximumFractionDigits: 0 }); };
  var money2 = function (n) { return "$" + n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };

  /* Sock model: tier suggests, buyer decides. Suggested mode keeps the old
     behavior — auto-upgrade to a model that carries the kit color. An
     explicit pick (sockWanted) locks the model; if it isn't made in the kit
     color we keep the model and substitute the color instead, same rule as
     shorts. ignoreWanted = marketing prices (hero "from $") that must not
     follow one buyer's pick. */
  function resolveSock(colorKey, tier, ignoreWanted) {
    tier = tier || state.tier;
    var models = sockModelsFor(colorKey), pref = tier.sock;
    var key, colorUsed = colorKey, subbed = false;
    if (!ignoreWanted && sockWanted && SOCKS[sockWanted]) {
      key = sockWanted;
      if (models.indexOf(key) === -1) {
        var m = CATALOG.socks[key] || {};
        var order = colorKey === "black" ? ["white", "black"] : ["black", "white"];
        colorUsed = order.filter(function (k) { return m[k]; })[0] ||
          COLOR_ORDER.filter(function (k) { return m[k]; })[0] || colorKey;
        subbed = colorUsed !== colorKey;
      }
    } else {
      key = models.indexOf(pref) > -1 ? pref : (models.indexOf("copa") > -1 ? "copa" : (models[0] || pref));
    }
    var s = SOCKS[key];
    var exact = sockArtFor(key, colorUsed); /* per-color art from the catalog, or null */
    return { key: key, name: s.name, art: exact || s.art, artExact: exact, price: s.price,
             upgraded: (ignoreWanted || !sockWanted) && key !== pref,
             colorKey: colorUsed, subbed: subbed };
  }
  /* home/away: any doubled piece splits its qty — extra spares stay home color */
  function awayActive() { return state.kit.j > 1 || state.kit.s > 1 || state.kit.k > 1; }
  /* the Step-3 away prompt: doubles the jersey (and socks, if in the kit)
     so the away swatches appear — respects a jerseys-only kit */
  function promptAway() {
    state.kit.j = Math.max(state.kit.j, 2);
    if (state.kit.k > 0) state.kit.k = Math.max(state.kit.k, 2);
  }
  function splitQty(n) {
    return n >= 2 ? { home: Math.ceil(n / 2), away: Math.floor(n / 2) } : { home: n, away: 0 };
  }
  /* What the colors would be under a given tier — used both to commit state
     (renderSwatches) and to price the other tier cards accurately. */
  function effectiveColors(t) {
    var list = tierColors(t);
    var c = list.indexOf(state.color) > -1 ? state.color : list[0];
    var c2;
    if (color2Wanted && list.indexOf(color2Wanted) > -1) c2 = color2Wanted;
    else if (list.indexOf(state.color2) > -1) c2 = state.color2;
    else c2 = list.indexOf("white") > -1 ? "white" : list[0];
    /* until the buyer picks explicitly, default the away color to a contrast */
    if (!color2Wanted && awayActive() && c2 === c) {
      var alt = c === "white" ? "black" : "white";
      c2 = list.indexOf(alt) > -1 ? alt : (list.filter(function (x) { return x !== c; })[0] || c);
    }
    return { color: c, color2: c2 };
  }
  function prices() { return state.tier.price[state.gender] || state.tier.price.M; }

  /* Single source of truth for the per-piece home/away expansion.
     Every consumer (piece cards, quote summary, printable estimate,
     money model) reads this so they can never disagree.
     art = exact per-color catalog art, falling back to the tier-level
     legacy art; img only ever derives from an exact catalog art. */
  function kitVariants() {
    var t = state.tier, p = prices(), k = state.kit;
    var mkGarment = function (piece, name, unit) {
      return function (ck, qty, tag) {
        var g = resolveGarment(piece, ck), c = COLORS[g.colorKey];
        return { qty: qty, tag: tag, hex: c.hex, label: c.label, name: name,
                 art: g.art || t.art[piece], img: imgFor(g.art), unit: unit,
                 subbed: g.subbed, want: ck };
      };
    };
    var mkSock = function (ck, qty, tag) {
      var sk = resolveSock(ck), c = COLORS[sk.colorKey];
      return { qty: qty, tag: tag, hex: c.hex, label: c.label, name: sk.name,
               art: sk.art, img: imgFor(sk.artExact), unit: sk.price,
               sockKey: sk.key, upgraded: sk.upgraded, subbed: sk.subbed, want: ck };
    };
    var piece = function (role, key, n, mk) {
      var sq = splitQty(n);
      return { role: role, key: key, n: n,
               vars: [mk(state.color, sq.home, "Home"), mk(state.color2, sq.away, "Away")] };
    };
    return [
      piece("Jersey", "j", k.j, mkGarment("j", t.jersey, p.j)),
      piece("Shorts", "s", k.s, mkGarment("s", t.short, p.s)),
      piece("Socks", "k", k.k, mkSock)
    ];
  }
  function decoPer() {
    var j = 0, sh = 0;
    DECO_ITEMS.forEach(function (d) { if (state.deco[d.id]) { if (d.on === "j") j += d.price; else sh += d.price; } });
    return { j: j, sh: sh };
  }

  /* ---- money model ---- */
  function calc() {
    var p = prices(), dp = decoPer(), k = state.kit;
    var variants = kitVariants();
    var goodsPer = variants.reduce(function (sum, pc) {
      return sum + pc.vars.reduce(function (s, v) { return s + v.unit * v.qty; }, 0);
    }, 0);
    var addonPer = 0, teamOnce = 0, piecesPer = k.j + k.s + k.k, teamPieces = 0;
    ADDONS.forEach(function (a) {
      var n = state.addons[a.id] || 0;
      if (!n) return;
      if (a.team) { teamOnce += a.price * n; teamPieces += n; }
      else { addonPer += a.price * n; piecesPer += n; }
    });
    var pieces = piecesPer * state.qty + teamPieces;
    var deco = dp.j * k.j + dp.sh * k.s;
    var br = BREAKS.slice().reverse().filter(function (b) { return pieces >= b.min; })[0] || BREAKS[0];
    var goodsNet = (goodsPer + addonPer) * (1 - br.off);
    var teamNet = teamOnce * (1 - br.off);
    var perPlayer = goodsNet + deco;
    return {
      p: p, variants: variants, dp: dp, br: br, pieces: pieces,
      goodsPer: goodsPer, addonPer: addonPer, decoPer: deco, goodsNet: goodsNet,
      perPlayer: perPlayer, teamOnce: teamOnce, teamNet: teamNet,
      listPer: goodsPer + addonPer + deco,
      total: perPlayer * state.qty + teamNet,
      saved: (goodsPer + addonPer - goodsNet) * state.qty + (teamOnce - teamNet)
    };
  }

  /* ---- shareable URL state ---- */
  function syncURL() {
    var q = new URLSearchParams();
    q.set("tier", state.tier.id);
    q.set("cut", state.gender);
    q.set("color", state.color);
    if (awayActive()) q.set("color2", state.color2);
    if (sockWanted) q.set("sock", sockWanted);
    q.set("kit", state.kit.j + "-" + state.kit.s + "-" + state.kit.k);
    q.set("roster", state.qty);
    var adds = ADDONS.filter(function (a) { return state.addons[a.id] > 0; })
      .map(function (a) { return a.id + ":" + state.addons[a.id]; }).join(",");
    if (adds) q.set("addons", adds);
    var deco = DECO_ITEMS.filter(function (d) { return state.deco[d.id]; })
      .map(function (d) { return d.id; }).join(",");
    if (deco) q.set("deco", deco); else q.set("deco", "none");
    if (state.needBy) {
      var d = state.needBy;
      q.set("need", d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0"));
    }
    history.replaceState(null, "", location.pathname + "?" + q.toString());
  }
  function restoreFromURL() {
    var q = new URLSearchParams(location.search);
    if (!q.has("tier")) return;
    var t = TIERS.filter(function (x) { return x.id === q.get("tier"); })[0];
    if (t) state.tier = t;
    if (["M", "W", "Y"].indexOf(q.get("cut")) > -1) state.gender = q.get("cut");
    if (COLORS[q.get("color")]) state.color = q.get("color");
    if (COLORS[q.get("color2")]) { state.color2 = q.get("color2"); color2Wanted = state.color2; }
    if (SOCKS[q.get("sock")]) sockWanted = q.get("sock");
    var kit = (q.get("kit") || "").split("-").map(Number);
    if (kit.length === 3 && kit.every(function (n) { return n >= 0 && n <= 4; })) {
      state.kit = { j: kit[0], s: kit[1], k: kit[2] };
    }
    var r = parseInt(q.get("roster"), 10);
    if (r >= 1 && r <= 500) state.qty = r;
    (q.get("addons") || "").split(",").forEach(function (pair) {
      var bits = pair.split(":"), a = ADDONS.filter(function (x) { return x.id === bits[0]; })[0];
      var n = parseInt(bits[1], 10);
      if (a && n >= 0) state.addons[a.id] = Math.min(n, a.max);
    });
    if (q.has("deco")) {
      DECO_ITEMS.forEach(function (d) { state.deco[d.id] = false; });
      if (q.get("deco") !== "none") {
        q.get("deco").split(",").forEach(function (id) {
          if (state.deco.hasOwnProperty(id)) state.deco[id] = true;
        });
      }
    }
    if (q.has("need")) {
      var nb = q.get("need").split("-").map(Number);
      if (nb.length === 3) {
        state.needBy = new Date(nb[0], nb[1] - 1, nb[2]);
        var input = $("auNeedBy");
        if (input) input.value = q.get("need");
      }
    }
  }

  /* ---- quote summary ---- */
  function kitSummaryText() {
    var r = calc(), t = state.tier, c = COLORS[state.color], c2 = COLORS[state.color2], k = state.kit;
    var g = GENDERS.filter(function (x) { return x.k === state.gender; })[0].label;
    var away = awayActive();
    var lines = [];
    lines.push("KIT: " + t.name + " — " + t.jersey.replace(" Jersey", "") + " (reorder-safe through " + t.life + ")");
    lines.push("Cut: " + g + (away ? " · Home: " + c.label + " · Away: " + c2.label : " · Color: " + c.label));
    var pieces = [];
    r.variants.forEach(function (pc) {
      if (!pc.n) return;
      var vs = pc.vars.filter(function (v) { return v.qty > 0; });
      if (vs.length === 1) pieces.push(pc.n + "x " + vs[0].name + " (" + money(vs[0].unit) + ")");
      else if (vs[0].name === vs[1].name)
        pieces.push(vs[0].qty + "x " + vs[0].name + " " + vs[0].label + " + " + vs[1].qty + "x " + vs[1].label + " (" + money(vs[0].unit) + " ea)");
      else
        pieces.push(vs[0].qty + "x " + vs[0].name + " " + vs[0].label + " (" + money(vs[0].unit) + ") + " +
          vs[1].qty + "x " + vs[1].name + " " + vs[1].label + " (" + money(vs[1].unit) + ")");
    });
    lines.push("Per player: " + pieces.join(", "));
    var subNotes = [], seenSub = {};
    r.variants.forEach(function (pc) {
      pc.vars.forEach(function (v) {
        if (!v.qty || !v.subbed || seenSub[pc.role + v.want]) return;
        seenSub[pc.role + v.want] = true;
        subNotes.push(pc.role + " in " + v.label + " (" + v.name + " isn’t made in " + COLORS[v.want].label + ")");
      });
    });
    if (subNotes.length) lines.push("Note: " + subNotes.join("; "));
    var adds = ADDONS.filter(function (a) { return state.addons[a.id] > 0; })
      .map(function (a) { return state.addons[a.id] + "x " + a.name + (a.team ? " (per team)" : ""); });
    if (adds.length) lines.push("Add-ons: " + adds.join(", "));
    var deco = DECO_ITEMS.filter(function (d) { return state.deco[d.id]; })
      .map(function (d) { return d.name; });
    lines.push("Decoration: " + (deco.length ? deco.join(", ") : "Blank — no decoration"));
    lines.push("Roster: " + state.qty + " players");
    if (state.needBy) lines.push("Need by: " + fmtDate(state.needBy) + " " + state.needBy.getFullYear());
    lines.push("Estimated: " + money(r.perPlayer) + "/player · " + money(r.total) + " team total" +
      " · " + r.pieces + " pieces" +
      (r.br.off ? " (" + Math.round(r.br.off * 100) + "% team discount applied)" : ""));
    lines.push("Kit link: " + location.href);
    return lines.join("\n");
  }
  function updateSummary() {
    var ta = $("auQuoteSummary");
    if (ta && !summaryEdited) ta.value = kitSummaryText();
  }

  /* ---- renders ---- */
  function renderGenders() {
    $("auGenders").innerHTML = GENDERS.map(function (g) {
      var missing = !state.tier.price[g.k];
      return '<button class="qty" type="button" aria-pressed="' + (g.k === state.gender) + '" data-gender="' + g.k + '"' +
        (missing ? ' data-missing="1"' : "") + ">" + g.label + (missing ? " —" : "") + "</button>";
    }).join("");
    $("auGenderNote").innerHTML = state.tier.price[state.gender] ? "" :
      '<p class="note"><b>Not in this range:</b> adidas doesn’t cut ' +
      GENDERS.filter(function (g) { return g.k === state.gender; })[0].label + " in " +
      state.tier.jersey.replace(" Jersey", "") +
      ". Squadra 25, Tiro 26 League and Tiro 26 Competition all do — or we can put your women’s players in the men’s cut, which plenty of teams do.</p>";
  }

  function renderTiers() {
    var k = state.kit, skq = splitQty(k.k);
    $("auTiers").innerHTML = TIERS.map(function (t) {
      var p = t.price[state.gender] || t.price.M;
      var eff = effectiveColors(t); /* the colors this tier would actually sell */
      var per = p.j * k.j + p.s * k.s +
        resolveSock(eff.color, t).price * skq.home + resolveSock(eff.color2, t).price * skq.away;
      return '<button class="tier" type="button" aria-pressed="' + (t.id === state.tier.id) + '" data-tier="' + t.id + '">' +
        (t.flag ? '<span class="flag">' + t.flag + "</span>" : "") +
        '<span class="rank">' + t.rank + '</span><span class="tname">' + t.name + "</span>" +
        '<span class="fam">' + t.note + "</span>" +
        '<span class="price">' + money(per) + "<small>kit, before deco</small></span></button>";
    }).join("");
  }

  function renderTake() {
    var t = state.tier;
    $("auTake").innerHTML =
      '<div class="th">Coach’s take — ' + t.name + "</div>" +
      "<p>" + t.take + "</p>" +
      '<div class="specs">' +
      "<span>Fabric <b>" + t.spec.fabric + "</b></span>" +
      "<span>Tech <b>" + t.spec.tech + "</b></span>" +
      "<span>Sizes <b>" + t.spec.sizes + "</b></span>" +
      "<span>Fit <b>Slim — every adidas teamwear range</b></span>" +
      "</div>";
  }

  function renderSwatches() {
    var list = tierColors(state.tier);
    var eff = effectiveColors(state.tier);
    state.color = eff.color;
    state.color2 = eff.color2;
    var away = awayActive();
    var row = function (selected, attr) {
      return list.map(function (key) {
        var c = COLORS[key];
        return '<button class="sw" type="button" aria-pressed="' + (key === selected) + '" ' + attr + '="' + key + '" title="' + c.label + '">' +
          '<span class="chip" style="background:' + c.hex + '"></span><span class="cname">' + c.label + "</span></button>";
      }).join("");
    };
    $("auSwatches").innerHTML = row(state.color, "data-color");
    var homeTag = $("auHomeTag"), awayGroup = $("auAwayGroup"), awayTag = $("auAwayTag");
    if (homeTag) homeTag.hidden = !away;
    if (awayGroup) {
      awayGroup.hidden = false;
      if (away) {
        $("auSwatches2").innerHTML = row(state.color2, "data-color2");
        if (awayTag) {
          var doubled = [];
          if (state.kit.j > 1) doubled.push("jersey");
          if (state.kit.s > 1) doubled.push("shorts");
          if (state.kit.k > 1) doubled.push("socks");
          awayTag.textContent = "Away — your 2nd " +
            (doubled.length === 1 && doubled[0] === "socks" ? "pair of socks" : doubled.join(" & "));
        }
      } else {
        /* single kit — keep the away spot visible with a one-tap path in */
        if (awayTag) awayTag.textContent = "Away";
        $("auSwatches2").innerHTML =
          '<button type="button" class="awayprompt" data-awayprompt>Playing home &amp; away? ' +
          "<b>Add a second jersey" + (state.kit.k > 0 ? " + socks" : "") + " &rarr;</b></button>";
      }
    }
  }

  function renderPresets() {
    var k = state.kit;
    $("auPresets").innerHTML = PRESETS.map(function (pr) {
      var on = pr.j === k.j && pr.s === k.s && pr.k === k.k;
      return '<button class="preset" type="button" aria-pressed="' + on + '" data-preset="' + pr.id + '"><b>' + pr.label + "</b> · " + pr.sub + "</button>";
    }).join("") + '<span class="preset" style="cursor:default;border-style:dashed">or set each piece below</span>';
  }

  function stepper(role, val, max) {
    return '<span class="stepper">' +
      '<button type="button" data-step="' + role + '" data-dir="-1" aria-label="Fewer"' + (val <= 0 ? " disabled" : "") + ">−</button>" +
      '<span class="val">' + val + "</span>" +
      '<button type="button" data-step="' + role + '" data-dir="1" aria-label="More"' + (val >= max ? " disabled" : "") + ">+</button></span>";
  }

  function sockChips() {
    var cur = resolveSock(state.color).key;
    return '<div class="sockpick">' + SOCK_ORDER.map(function (m) {
      var s = SOCKS[m], sug = state.tier.sock === m;
      return '<button type="button" class="sockchip" aria-pressed="' + (m === cur) + '" data-sock="' + m + '">' +
        "<b>" + s.name + "</b><span>" + money(s.price) + (sug ? " · Suggested" : "") + "</span></button>";
    }).join("") + "</div>";
  }

  function renderPieces() {
    var t = state.tier;
    var pieces = kitVariants();

    var varBlock = function (v, showTag, showName) {
      return '<div class="pvar">' +
        (v.img ? '<img class="pimg" src="' + v.img + '" alt="adidas ' + v.name + " — " + v.label + '" decoding="async" width="130" height="130">' : "") +
        (showTag ? '<span class="pv-tag">' + v.tag + "</span>" : "") +
        '<span class="pv-meta"><span class="dot" style="background:' + v.hex + '"></span>' +
        (v.qty ? v.qty + "× " : "") + v.label +
        (v.subbed ? " <small>· closest made</small>" : "") + "</span>" +
        (showName ? '<span class="pv-name">' + v.name + "</span>" : "") +
        '<span class="pv-art">' + (v.art || "—") + " · " + money(v.unit) + " ea</span>" +
        "</div>";
    };
    $("auPieces").innerHTML = pieces.map(function (pc) {
      var shown = pc.n === 0 ? [pc.vars[0]] : pc.vars.filter(function (v) { return v.qty > 0; });
      var showTags = shown.length > 1;
      var amt = pc.vars.reduce(function (sum, v) { return sum + v.unit * v.qty; }, 0);
      return '<div class="piece ' + (pc.n === 0 ? "off" : "") + '">' +
        '<span class="role">' + pc.role + "</span>" +
        '<span class="pname">adidas ' + pc.vars[0].name + "</span>" +
        '<div class="pvars">' + shown.map(function (v, i) {
          return varBlock(v, showTags, i > 0 && v.name !== shown[0].name);
        }).join("") + "</div>" +
        (pc.role === "Socks" ? sockChips() : "") +
        '<span class="meta">' +
        '<span class="qtywrap">' + stepper(pc.key, pc.n, 4) + '<span class="per">per player</span></span>' +
        '<span class="amt">' + money(amt) + "</span>" +
        "</span>" +
        "</div>";
    }).join("");

    var sockVars = pieces[2].vars;
    var noteFor = function (v, dual) {
      return '<p class="note"><b>Sock swapped to match:</b> ' + SOCKS[t.sock].name + " doesn’t come in " + v.label.toLowerCase() +
        ", so we’ve matched " + (dual ? "your " + v.label.toLowerCase() + " pair" : "you") + " to " + v.name +
        " at " + money(v.unit) + " — same colour, same over-the-calf cut, NCAA compliant.</p>";
    };
    var noteHtml = "";
    /* piece not made in the kit color → color substituted (garments always;
       socks only when the buyer locked a model that lacks the color) */
    var seenSub = {};
    pieces.forEach(function (pc) {
      if (!pc.n) return;
      pc.vars.forEach(function (v) {
        if (!v.qty || !v.subbed) return;
        var sig = pc.role + v.want + v.label;
        if (seenSub[sig]) return;
        seenSub[sig] = true;
        var tail = pc.role === "Socks"
          ? "Keep it, pick another sock model above that comes in " + COLORS[v.want].label.toLowerCase() +
            ", or tell us in your quote."
          : "Want a different " + pc.role.toLowerCase() + " colour? Say so in your quote and we’ll set it during the stock check.";
        noteHtml += '<p class="note"><b>' + pc.role + " matched to " + v.label + ":</b> adidas doesn’t make " +
          v.name + " in " + COLORS[v.want].label.toLowerCase() + " — " + v.label.toLowerCase() +
          " is the classic pairing. " + tail + "</p>";
      });
    });
    if (pieces[2].n > 0) {
      var dual = sockVars[1].qty > 0;
      if (sockVars[0].upgraded) noteHtml += noteFor(sockVars[0], dual);
      if (dual && sockVars[1].upgraded && state.color2 !== state.color) noteHtml += noteFor(sockVars[1], true);
    }
    $("auSockNote").innerHTML = noteHtml;
  }

  function renderAddons() {
    $("auAddons").innerHTML = ADDONS.map(function (a) {
      var n = state.addons[a.id] || 0;
      return '<div class="addon ' + (n ? "on" : "") + '">' +
        '<div class="info"><div class="an">' + a.name + '</div><div class="as">' + a.sub + "</div></div>" +
        '<div class="ap">' + money(a.price) + "</div>" +
        stepper("addon:" + a.id, n, a.max) +
        "</div>";
    }).join("");
  }

  function renderDecos() {
    var k = state.kit;
    $("auDecoPresets").innerHTML = DECO_PRESETS.map(function (pr) {
      var on = DECO_ITEMS.every(function (d) { return !!state.deco[d.id] === (pr.items.indexOf(d.id) > -1); });
      var per = pr.items.reduce(function (sum, id) {
        var d = DECO_ITEMS.filter(function (x) { return x.id === id; })[0];
        return sum + d.price * (d.on === "j" ? k.j : k.s);
      }, 0);
      return '<button class="preset" type="button" aria-pressed="' + on + '" data-decopreset="' + pr.id + '"><b>' + pr.label + "</b> · " + (per ? money2(per) : "free") + "</button>";
    }).join("");

    $("auDecoItems").innerHTML = DECO_ITEMS.map(function (d) {
      var n = d.on === "j" ? k.j : k.s;
      var on = !!state.deco[d.id];
      var dis = n === 0;
      return '<div class="addon ' + (on && !dis ? "on" : "") + " " + (dis ? "off" : "") + '">' +
        '<div class="info"><div class="an">' + d.name + "</div>" +
        '<div class="as">' + d.sub + (n > 1 && on ? " · ×" + n + " garments" : "") + (dis ? " · not in kit" : "") + "</div></div>" +
        '<div class="ap">' + money2(d.price) + "</div>" +
        '<button class="tick ' + (on && !dis ? "on" : "") + '" type="button" data-deco="' + d.id + '"' + (dis ? " disabled" : "") +
        ' aria-pressed="' + on + '" aria-label="' + d.name.replace(/"/g, "&quot;") + '">' + (on && !dis ? "✓" : "+") + "</button>" +
        "</div>";
    }).join("");

    var dp = decoPer();
    $("auDecoNote").innerHTML = (dp.j > 0 && k.j > 1)
      ? '<p class="note"><b>Two jerseys, two sets of numbers.</b> Decoration is charged per garment, so ' + money2(dp.j) +
        " of jersey work across " + k.j + " jerseys is " + money2(dp.j * k.j) +
        " a player. Teams miss this constantly and get a surprise on the invoice — you won’t.</p>"
      : "";
  }

  function renderQtys() {
    $("auQtys").innerHTML = [11, 14, 18, 22, 30, 48].map(function (n) {
      return '<button class="qty" type="button" aria-pressed="' + (n === state.qty) + '" data-qty="' + n + '">' + n + "</button>";
    }).join("");
  }

  function renderHeroDeal() {
    var el = $("auHeroLadder");
    if (!el) return;
    el.innerHTML = BREAKS.filter(function (b) { return b.off; }).map(function (b) {
      return '<div class="hd-rung"><b>Save ' + Math.round(b.off * 100) + "%</b>" + b.label + "</div>";
    }).join("");
    /* cheapest complete kit across tiers, 1-1-1 */
    var low = Infinity;
    TIERS.forEach(function (t) {
      var pr = t.price.M;
      var cheapestSock = Math.min.apply(null, tierColors(t, "M").map(function (c) {
        return resolveSock(c, t, true).price;
      }));
      low = Math.min(low, pr.j + pr.s + cheapestSock);
    });
    var from = $("auHeroFrom");
    if (from) from.textContent = money(low);
  }

  function renderLadder() {
    var cur = calc().br;
    $("auLadder").innerHTML = BREAKS.map(function (b) {
      return '<div class="rung ' + (b.min === cur.min ? "on" : "") + '"><b>' + (b.off ? Math.round(b.off * 100) + "% off" : "List") + "</b>" + b.label + "</div>";
    }).join("");
  }

  function renderTotals() {
    var r = calc(), t = state.tier;
    $("auBreakdown").innerHTML =
      "<span>Kit <b>" + money(r.goodsPer) + "</b></span>" +
      (r.addonPer ? "<span>Add-ons <b>" + money(r.addonPer) + "</b></span>" : "") +
      (r.br.off ? "<span>Team discount <b>−" + money(r.goodsPer + r.addonPer - r.goodsNet) + "</b></span>" : "") +
      "<span>Decoration <b>" + (r.decoPer ? money2(r.decoPer) : "—") + "</b></span>" +
      (r.teamOnce ? "<span>Team items <b>" + money(r.teamNet) + "</b></span>" : "");

    $("auPerPlayer").innerHTML = r.br.off
      ? money(r.perPlayer) + ' <span class="was">' + money(r.listPer) + "</span>"
      : money(r.perPlayer);
    $("auPerPlayerSub").textContent = r.decoPer ? "Kit + decoration" : "Blank kit";
    $("auTeamTotal").textContent = money(r.total);
    $("auSavings").textContent = r.saved > 0 ? "You save " + money(r.saved) + " · " + r.pieces + " pieces" : r.pieces + " pieces · discount starts at 12";
    $("auLifeYear").textContent = t.life;
    $("auLifeSub").textContent = t.life >= 2029 ? "Longest runway adidas offers" : "Add players through this season";
  }

  /* ================= timing ================= */
  function addBusinessDays(from, n) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }
  function businessDaysBetween(a, b) {
    if (b <= a) return 0;
    var d = new Date(a.getTime()), n = 0;
    while (d < b) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) n++;
    }
    return n;
  }
  function fmtDate(d) { return d.toLocaleDateString("en-US", { month: "long", day: "numeric" }); }

  function renderTiming() {
    var box = $("auTiming");
    if (!state.needBy) { box.innerHTML = ""; return; }
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var need = state.needBy;
    var dp = decoPer();
    var decorated = (dp.j > 0 || dp.sh > 0);
    var lead = LEAD_BLANK + (decorated ? LEAD_DECO : 0);
    var have = businessDaysBetween(today, need);
    var slack = have - lead;

    if (need <= today) {
      box.innerHTML = '<div class="timing bad"><span class="ic">✕</span><div>' +
        "<b>That date has passed.</b> Pick your first game or the day you need kit in hands and we’ll work back from it.</div></div>";
      return;
    }
    var orderBy = new Date(need.getTime());
    var back = lead;
    while (back > 0) {
      orderBy.setDate(orderBy.getDate() - 1);
      var wd = orderBy.getDay();
      if (wd !== 0 && wd !== 6) back--;
    }

    var kind = decorated ? "decorated" : "blank";
    if (slack >= 10) {
      box.innerHTML = '<div class="timing ok"><span class="ic">✓</span><div>' +
        "<b>Your timeline is comfortable.</b> A " + kind + " order needs about " + lead + " working days. " +
        "Order by <b>" + fmtDate(orderBy) + "</b> and you have roughly " + slack + " working days of cushion before " + fmtDate(need) + ".</div></div>";
    } else if (slack >= 0) {
      box.innerHTML = '<div class="timing warn"><span class="ic">!</span><div>' +
        "<b>This works, but there’s no room to spare.</b> A " + kind + " order needs about " + lead + " working days, " +
        "and you have " + have + ". Order by <b>" + fmtDate(orderBy) + "</b> at the latest. " +
        "Send your roster now and we’ll confirm adidas has your sizes before you commit.</div></div>";
    } else {
      box.innerHTML = '<div class="timing bad"><span class="ic">!</span><div>' +
        "<b>That’s tight for " + fmtDate(need) + ".</b> A " + kind + " order normally takes about " + lead +
        " working days and there are " + have + " left. " +
        (decorated ? "Going blank for the opener saves roughly " + LEAD_DECO + " working days, and we can decorate later. " : "") +
        "Call us before you order — sometimes we can pull it off, and we’ll tell you honestly if we can’t.</div></div>";
    }
  }

  function renderLifecycle() {
    var el = $("auLifeRows");
    if (!el) return;
    var A0 = 2025, A1 = 2030;
    el.innerHTML = LIFECYCLE.map(function (r) {
      return '<div class="life-row"><div class="lname">' + r.name + "<em>" + r.sub + "</em></div>" +
        '<div class="track"><div class="bar ' + r.cls + '" style="left:' + (((r.start - A0) / (A1 - A0)) * 100) +
        "%;width:" + (((r.end - r.start) / (A1 - A0)) * 100) + '%">' + r.tag + "</div></div></div>";
    }).join("");
  }

  function paint() {
    renderGenders(); renderSwatches(); renderTiers(); renderTake(); renderPresets();
    renderPieces(); renderAddons(); renderDecos(); renderQtys();
    renderLadder(); renderTotals(); renderTiming();
    syncURL(); updateSummary();
  }

  /* ---- events ---- */
  $("auTiers").addEventListener("click", function (e) {
    var b = e.target.closest("[data-tier]"); if (!b) return;
    state.tier = TIERS.filter(function (t) { return t.id === b.dataset.tier; })[0]; paint();
  });
  $("auGenders").addEventListener("click", function (e) {
    var b = e.target.closest("[data-gender]"); if (!b) return;
    state.gender = b.dataset.gender; paint();
  });
  $("auSwatches").addEventListener("click", function (e) {
    var b = e.target.closest("[data-color]"); if (!b) return;
    state.color = b.dataset.color; paint();
  });
  $("auSwatches2").addEventListener("click", function (e) {
    if (e.target.closest("[data-awayprompt]")) { promptAway(); paint(); return; }
    var b = e.target.closest("[data-color2]"); if (!b) return;
    state.color2 = b.dataset.color2; color2Wanted = state.color2; paint();
  });
  $("auPresets").addEventListener("click", function (e) {
    var b = e.target.closest("[data-preset]"); if (!b) return;
    var pr = PRESETS.filter(function (x) { return x.id === b.dataset.preset; })[0];
    state.kit = { j: pr.j, s: pr.s, k: pr.k }; paint();
  });
  function handleStep(e) {
    var sk = e.target.closest("[data-sock]");
    if (sk) { sockWanted = sk.dataset.sock; paint(); return; }
    var b = e.target.closest("[data-step]"); if (!b) return;
    var key = b.dataset.step, dir = +b.dataset.dir;
    if (key.indexOf("addon:") === 0) {
      var id = key.slice(6), a = ADDONS.filter(function (x) { return x.id === id; })[0];
      state.addons[id] = Math.max(0, Math.min(a.max, (state.addons[id] || 0) + dir));
      /* add-ons never change the kit pieces — skip the full paint so the
         product photos aren't torn out and re-inserted */
      renderAddons(); renderTotals(); syncURL(); updateSummary();
    } else {
      state.kit[key] = Math.max(0, Math.min(4, state.kit[key] + dir));
      paint();
    }
  }
  $("auPieces").addEventListener("click", handleStep);
  $("auAddons").addEventListener("click", handleStep);
  $("auDecoItems").addEventListener("click", function (e) {
    var b = e.target.closest("[data-deco]"); if (!b || b.disabled) return;
    state.deco[b.dataset.deco] = !state.deco[b.dataset.deco];
    renderDecos(); renderTotals(); renderTiming(); syncURL(); updateSummary();
  });
  $("auDecoPresets").addEventListener("click", function (e) {
    var b = e.target.closest("[data-decopreset]"); if (!b) return;
    var pr = DECO_PRESETS.filter(function (x) { return x.id === b.dataset.decopreset; })[0];
    DECO_ITEMS.forEach(function (d) { state.deco[d.id] = pr.items.indexOf(d.id) > -1; });
    renderDecos(); renderTotals(); renderTiming(); syncURL(); updateSummary();
  });
  $("auQtys").addEventListener("click", function (e) {
    var b = e.target.closest("[data-qty]"); if (!b) return;
    state.qty = +b.dataset.qty; $("auCustomQty").value = "";
    renderQtys(); renderLadder(); renderTotals(); syncURL(); updateSummary();
  });
  $("auCustomQty").addEventListener("input", function (e) {
    var v = parseInt(e.target.value, 10);
    if (!isNaN(v) && v > 0) {
      state.qty = Math.min(v, 500);
      renderQtys(); renderLadder(); renderTotals(); syncURL(); updateSummary();
    }
  });
  $("auNeedBy").addEventListener("change", function (e) {
    var v = e.target.value;
    if (!v) { state.needBy = null; renderTiming(); syncURL(); updateSummary(); return; }
    var bits = v.split("-").map(Number);
    state.needBy = new Date(bits[0], bits[1] - 1, bits[2]);
    renderTiming(); syncURL(); updateSummary();
  });

  /* ---- quote panel ---- */
  var quotePanel = $("auQuotePanel");
  var quoteBtn = $("auQuoteOpen");
  function openQuote(scroll) {
    if (!quotePanel) return;
    updateSummary();
    quotePanel.removeAttribute("hidden");
    if (quoteBtn) quoteBtn.setAttribute("aria-expanded", "true");
    if (scroll) {
      quotePanel.scrollIntoView({ behavior: "smooth", block: "nearest" });
      var first = quotePanel.querySelector("input[name='contact[name]']");
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
    }
  }
  if (quoteBtn && quotePanel) {
    quoteBtn.addEventListener("click", function () {
      if (quotePanel.hasAttribute("hidden")) {
        openQuote(true);
      } else {
        quotePanel.setAttribute("hidden", "");
        quoteBtn.setAttribute("aria-expanded", "false");
      }
    });
  }
  /* any [data-open-quote] button (final CTA) opens the panel */
  root.addEventListener("click", function (e) {
    var b = e.target.closest("[data-open-quote]");
    if (!b) return;
    openQuote(false);
    quotePanel.scrollIntoView({ behavior: "smooth", block: "center" });
  });
  var ta = $("auQuoteSummary");
  if (ta) ta.addEventListener("input", function () { summaryEdited = true; });

  /* keep the shareable-link hidden field current at submit time */
  var quoteForm = quotePanel ? quotePanel.querySelector("form") : null;
  if (quoteForm) {
    quoteForm.addEventListener("submit", function () {
      var link = $("auQuoteLink");
      if (link) link.value = location.href;
    });
  }

  /* ---- copy link ---- */
  var copyBtn = $("auCopyLink");
  if (copyBtn) {
    copyBtn.addEventListener("click", function () {
      syncURL();
      var done = function () {
        var prev = copyBtn.textContent;
        copyBtn.textContent = "Link copied ✓";
        setTimeout(function () { copyBtn.textContent = prev; }, 2200);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(location.href).then(done, done);
      } else { done(); }
    });
  }

  /* ---- printable estimate ---- */
  function esc(s) {
    return String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }
  function estimateHTML(name, club) {
    var r = calc(), t = state.tier, c = COLORS[state.color], c2 = COLORS[state.color2], k = state.kit;
    var away = awayActive();
    var g = GENDERS.filter(function (x) { return x.k === state.gender; })[0].label;
    var now = new Date();
    var valid = new Date(now.getTime()); valid.setDate(valid.getDate() + 30);
    var fmtFull = function (d) { return d.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }); };
    var p2 = function (n) { return String(n).padStart(2, "0"); };
    var ref = "GK-" + String(now.getFullYear()).slice(2) + p2(now.getMonth() + 1) + p2(now.getDate()) + "-" + p2(now.getHours()) + p2(now.getMinutes());
    var kitLink = location.href;
    var phone = root.dataset.phone || "";
    var phoneTel = root.dataset.phoneTel || "";
    var logo = root.dataset.logo || "";
    if (logo.indexOf("//") === 0) logo = "https:" + logo; /* about:blank tab can't resolve protocol-relative URLs */
    var shopUrl = (root.dataset.shopUrl || "https://goalkicksoccer.com").replace(/^https?:\/\//, "");
    var trust = Array.prototype.map.call(root.querySelectorAll(".topstrip span"), function (el) {
      return esc(el.textContent.trim());
    }).join(" &nbsp;·&nbsp; ");

    var rows = "";
    var line = function (qty, item, art, unit, amt) {
      rows += '<tr><td class="c">' + qty + "</td><td>" + item + '</td><td class="c mono">' + (art || "—") +
        '</td><td class="r mono">' + money2(unit) + '</td><td class="r mono">' + money2(amt) + "</td></tr>";
    };
    r.variants.forEach(function (pc) {
      pc.vars.forEach(function (v) {
        if (!v.qty) return;
        line(v.qty, "adidas " + esc(v.name) + " — " + esc(v.label) +
          (v.subbed ? " <span class='fn'>(closest made — not cut in " + esc(COLORS[v.want].label) + ")</span>" : ""),
          v.art, v.unit, v.unit * v.qty);
      });
    });
    ADDONS.forEach(function (a) {
      var n = state.addons[a.id] || 0;
      if (!n || a.team) return;
      line(n, esc(a.name) + " — " + esc(a.sub).replace(/&amp;amp;/g, "&amp;"), "", a.price, a.price * n);
    });

    var listPer = r.goodsPer + r.addonPer;
    rows += '<tr class="sum"><td colspan="4">Per-player subtotal · adidas 2027 MSRP</td><td class="r mono">' + money2(listPer) + "</td></tr>";
    if (r.br.off) {
      rows += '<tr class="disc"><td colspan="4">Team discount — ' + Math.round(r.br.off * 100) + "% at " + r.br.label + " (" + r.pieces + " in this order)" +
        '&nbsp;<span class="fn">*</span></td><td class="r mono">−' + money2(listPer - r.goodsNet) + "</td></tr>";
    }
    var anyDeco = false;
    DECO_ITEMS.forEach(function (d) {
      if (!state.deco[d.id]) return;
      var n = d.on === "j" ? k.j : k.s;
      if (!n) return;
      anyDeco = true;
      rows += '<tr><td class="c">' + n + "</td><td>Decoration — " + esc(d.name) + " (" + esc(d.sub) +
        ')</td><td class="c mono">—</td><td class="r mono">' + money2(d.price) + '</td><td class="r mono">' + money2(d.price * n) + "</td></tr>";
    });
    rows += '<tr class="tot"><td colspan="4">Per player' + (anyDeco ? " · kit + decoration" : " · blank kit") +
      '</td><td class="r mono">' + money2(r.perPlayer) + "</td></tr>";

    var teamRows = '<tr><td>' + state.qty + " players × " + money2(r.perPlayer) +
      ' per player</td><td class="r mono">' + money2(r.perPlayer * state.qty) + "</td></tr>";
    ADDONS.forEach(function (a) {
      var n = state.addons[a.id] || 0;
      if (!n || !a.team) return;
      teamRows += "<tr><td>" + n + " × " + esc(a.name) + " — " + esc(a.sub).replace(/&amp;amp;/g, "&amp;") +
        ' (per team' + (r.br.off ? ", after team discount" : "") + ')</td><td class="r mono">' + money2(a.price * n * (1 - r.br.off)) + "</td></tr>";
    });
    teamRows += '<tr class="grand"><td>Team total</td><td class="r mono">' + money2(r.total) + "</td></tr>";
    if (r.saved > 0) {
      teamRows += '<tr class="save"><td colspan="2">Your team pricing saves ' + money2(r.saved) + " against list at " + r.br.label + "</td></tr>";
    }

    var nextBr = BREAKS.filter(function (b) { return b.min > r.pieces; })[0];
    var facts = "";
    var fact = function (kk, vv) { facts += '<div class="fact"><span>' + kk + "</span><b>" + vv + "</b></div>"; };
    fact("Range", esc(t.jersey.replace(" Jersey", "")));
    fact("Cut", g);
    if (away) { fact("Home", esc(c.label)); fact("Away", esc(c2.label)); }
    else fact("Colour", esc(c.label));
    fact("Roster", state.qty + " players · " + r.pieces + " pieces");
    fact("Reorder-safe", "Through " + t.life);
    if (state.needBy) fact("Need-by", fmtFull(state.needBy));

    var deco = anyDeco;
    var leadNote = "Blank orders ship in about " + LEAD_BLANK + " working days" +
      (deco ? "; decoration adds roughly " + LEAD_DECO + " more" : "") + ".";

    return "<!DOCTYPE html><html><head><meta charset='utf-8'>" +
      "<meta name='viewport' content='width=device-width,initial-scale=1'>" +
      "<title>Goal Kick Soccer — Team Kit Estimate " + ref + "</title>" +
      "<style>" +
      "*{box-sizing:border-box;margin:0;padding:0;-webkit-print-color-adjust:exact;print-color-adjust:exact}" +
      "body{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,Arial,sans-serif;font-size:13px;line-height:1.5;color:#1c2b3a;background:#eef1f4}" +
      ".mono{font-family:ui-monospace,'SF Mono',Menlo,Consolas,monospace;font-variant-numeric:tabular-nums}" +
      ".sheet{max-width:820px;margin:26px auto;background:#fff;padding:44px 48px;box-shadow:0 2px 24px rgba(1,40,78,.14)}" +
      ".toolbar{max-width:820px;margin:18px auto 0;display:flex;justify-content:flex-end;gap:10px}" +
      ".toolbar button{cursor:pointer;font:700 13px/1 -apple-system,'Segoe UI',sans-serif;text-transform:uppercase;letter-spacing:.05em;border:0;border-radius:4px;padding:12px 20px;background:#f08026;color:#fff}" +
      ".toolbar .hint{align-self:center;font-size:12px;color:#5a6b7d;margin-right:auto}" +
      ".lh{display:flex;justify-content:space-between;align-items:flex-start;gap:20px;padding-bottom:18px;border-bottom:3px solid #01284e;position:relative}" +
      ".lh:after{content:'';position:absolute;left:0;bottom:-7px;width:90px;height:4px;background:#f08026}" +
      ".lh img{height:44px;width:auto}" +
      ".lh .co{font-size:11px;color:#5a6b7d;margin-top:8px;line-height:1.55}" +
      ".lh .doc{text-align:right}" +
      ".lh h1{font-size:21px;font-weight:800;letter-spacing:.02em;text-transform:uppercase;color:#01284e}" +
      ".lh .meta{font-size:11px;color:#5a6b7d;margin-top:6px;line-height:1.7}" +
      ".lh .meta b{color:#1c2b3a}" +
      ".parties{display:flex;gap:36px;margin:24px 0 20px}" +
      ".party{flex:1}" +
      ".party .k{font-size:10px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#f08026;margin-bottom:5px}" +
      ".party .v{font-size:14px;font-weight:700;color:#01284e}" +
      ".party .s{font-size:11.5px;color:#5a6b7d;line-height:1.55}" +
      ".kitband{display:flex;flex-wrap:wrap;background:#01284e;color:#fff;border-radius:4px;padding:14px 18px;gap:8px 30px;margin-bottom:20px}" +
      ".kitband .title{flex-basis:100%;font-size:15px;font-weight:800;text-transform:uppercase;letter-spacing:.03em}" +
      ".fact span{display:block;font-size:9px;letter-spacing:.13em;text-transform:uppercase;color:#8fa3bf}" +
      ".fact b{font-size:12.5px;font-weight:700}" +
      "table{width:100%;border-collapse:collapse;margin-bottom:4px}" +
      "th{font-size:9.5px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:#5a6b7d;text-align:left;padding:7px 9px;border-bottom:2px solid #01284e}" +
      "td{padding:7px 9px;border-bottom:1px solid #e3e8ee;vertical-align:top;font-size:12.5px}" +
      ".c{text-align:center}.r{text-align:right;white-space:nowrap}" +
      "tr.sum td{background:#f5f7fa;font-weight:700}" +
      "tr.disc td{background:#f5f7fa;color:#0f7b4f;font-weight:700}" +
      "tr.tot td{background:#e8edf3;font-weight:800;font-size:13.5px;border-bottom:2px solid #01284e}" +
      ".teamtbl{margin-top:14px}" +
      ".teamtbl td{font-size:13px}" +
      "tr.grand td{background:#01284e;color:#fff;font-weight:800;font-size:16px;padding:11px 9px}" +
      "tr.save td{color:#0f7b4f;font-weight:700;border-bottom:0;padding-top:8px}" +
      ".fn{color:#f08026;font-weight:700}" +
      ".foot-note{font-size:10.5px;color:#5a6b7d;margin:8px 0 0}" +
      ".boxes{display:flex;gap:14px;margin-top:22px}" +
      ".box{flex:1;border-radius:4px;padding:14px 16px;font-size:11.5px;line-height:1.6}" +
      ".box h3{font-size:10px;font-weight:700;letter-spacing:.13em;text-transform:uppercase;margin-bottom:5px}" +
      ".box.status{background:#fbeeda;color:#7c4a00}.box.status h3{color:#9a5b00}" +
      ".box.next{border:1.5px solid #01284e;color:#1c2b3a}.box.next h3{color:#f08026}" +
      ".box.next .tel{font-weight:800;color:#01284e;text-decoration:none}" +
      ".link{font-size:10px;word-break:break-all;color:#5a6b7d}" +
      ".pagefoot{margin-top:24px;padding-top:12px;border-top:1px solid #e3e8ee;font-size:10px;color:#8494a5;display:flex;justify-content:space-between;gap:12px;flex-wrap:wrap}" +
      "@media print{body{background:#fff;font-size:11.5px}.toolbar{display:none}" +
      ".sheet{max-width:none;margin:0;padding:0;box-shadow:none}" +
      "td{padding:5px 8px;font-size:11.5px}th{padding:5px 8px}" +
      ".parties{margin:16px 0 14px}.kitband{padding:11px 16px;margin-bottom:14px}" +
      ".lh img{height:38px}.lh{padding-bottom:13px}" +
      ".boxes{margin-top:14px}.box{padding:11px 14px;font-size:10.5px}" +
      ".pagefoot{margin-top:14px}" +
      "tr,.boxes,.box,.kitband,.parties{break-inside:avoid;page-break-inside:avoid}}" +
      "@page{size:letter;margin:0.5in}" +
      "</style></head><body>" +
      '<div class="toolbar"><span class="hint">Tip: choose "Save as PDF" in the print dialog to keep a copy.</span>' +
      '<button onclick="window.print()">Print / Save as PDF</button></div>' +
      '<div class="sheet">' +
      '<div class="lh">' +
      "<div>" + (logo ? '<img src="' + esc(logo) + '" alt="Goal Kick Soccer">' : '<div class="lh-name" style="font-size:20px;font-weight:800;color:#01284e">GOAL KICK SOCCER</div>') +
      '<div class="co">' + trust + "</div></div>" +
      '<div class="doc"><h1>Team Kit Estimate</h1><div class="meta">' +
      "Estimate <b>" + ref + "</b><br>Issued <b>" + fmtFull(now) + "</b><br>Valid through <b>" + fmtFull(valid) + "</b></div></div>" +
      "</div>" +
      '<div class="parties">' +
      '<div class="party"><div class="k">Prepared for</div>' +
      '<div class="v">' + (club ? esc(club) : (name ? esc(name) : "Your team")) + "</div>" +
      '<div class="s">' + (club && name ? esc(name) : "") + "</div></div>" +
      '<div class="party"><div class="k">Prepared by</div>' +
      '<div class="v">Goal Kick Soccer</div>' +
      '<div class="s">Spencer, Iowa' + (phone ? " · " + esc(phone) : "") + " · " + esc(shopUrl) + "</div></div>" +
      "</div>" +
      '<div class="kitband"><div class="title">' + esc(t.name) + " — adidas " + esc(t.jersey.replace(" Jersey", "")) + " kit</div>" + facts + "</div>" +
      "<table><thead><tr><th class='c' style='width:44px'>Qty/pl</th><th>Item</th><th class='c' style='width:80px'>Art. no.</th><th class='r' style='width:76px'>Unit</th><th class='r' style='width:86px'>Per player</th></tr></thead><tbody>" +
      rows + "</tbody></table>" +
      '<p class="foot-note"><span class="fn">*</span> Team discount counts every garment piece in the order — jerseys, shorts, socks and add-ons (12+ pieces 15%, 24+ 20%, 48+ 25%); decoration is priced per garment and not discounted. All garment prices are adidas 2027 MSRP.</p>' +
      '<table class="teamtbl"><tbody>' + teamRows + "</tbody></table>" +
      (nextBr ? '<p class="foot-note">At ' + nextBr.label + " your discount steps up to " + Math.round(nextBr.off * 100) + "% — worth checking if nearby teams want in.</p>" : "") +
      '<div class="boxes">' +
      '<div class="box status"><h3>Estimate — pending stock check</h3>' +
      "This is an estimate, not an invoice. Final pricing is confirmed after we verify your exact colours and sizes against live adidas stock. Tax and freight are not included. Nothing is charged until you approve. " + leadNote + "</div>" +
      '<div class="box next"><h3>Next step</h3>' +
      "Send this kit for a free stock check at the link below" + (phone ? ", or call team sales at <a class='tel' href='tel:" + esc(phoneTel) + "'>" + esc(phone) + "</a>" : "") +
      ". Schools and clubs can pay by purchase order.<br>" +
      '<span class="link">' + esc(kitLink) + "</span></div>" +
      "</div>" +
      '<div class="pagefoot"><span>Goal Kick Soccer · Authorized adidas team dealer since 2001</span><span>Estimate ' + ref + " · The link above rebuilds this exact kit</span></div>" +
      "</div>" +
      "<script>window.addEventListener('load',function(){setTimeout(function(){window.print()},400)})<" + "/script>" +
      "</body></html>";
  }

  function openEstimate() {
    syncURL();
    var name = ($("auEstName") ? $("auEstName").value : "").trim();
    var club = ($("auEstClub") ? $("auEstClub").value : "").trim();
    var w = window.open("", "_blank");
    if (!w) {
      alert("Your browser blocked the estimate tab — allow pop-ups for this site and try again.");
      return;
    }
    w.document.open();
    w.document.write(estimateHTML(name, club));
    w.document.close();
  }

  var estBtn = $("auEstimateOpen"), estPanel = $("auEstimatePanel");
  if (estBtn && estPanel) {
    estBtn.addEventListener("click", function () {
      if (estPanel.hasAttribute("hidden")) {
        /* reuse anything already typed into the stock-check form */
        var qn = $("auQName"), qc = $("auQClub");
        if (qn && qn.value && !$("auEstName").value) $("auEstName").value = qn.value;
        if (qc && qc.value && !$("auEstClub").value) $("auEstClub").value = qc.value;
        estPanel.removeAttribute("hidden");
        estBtn.setAttribute("aria-expanded", "true");
        estPanel.scrollIntoView({ behavior: "smooth", block: "nearest" });
        setTimeout(function () { $("auEstName").focus({ preventScroll: true }); }, 350);
      } else {
        estPanel.setAttribute("hidden", "");
        estBtn.setAttribute("aria-expanded", "false");
      }
    });
    var goBtn = $("auEstimateGo");
    if (goBtn) goBtn.addEventListener("click", openEstimate);
  }

  /* ---- boot ---- */
  restoreFromURL();
  paint();
  renderHeroDeal();
  renderLifecycle();

  /* returned from a form POST (success or errors) → reopen the panel */
  var formReturn = $("auFormReturn");
  if (formReturn) {
    openQuote(false);
    var target = formReturn.dataset.posted === "1" ? $("auQuoteSuccess") : quotePanel;
    if (target) setTimeout(function () {
      target.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 150);
    if (formReturn.dataset.posted === "1") summaryEdited = false;
  }
})();
